import { initGdp } from "./gio-report";
import SentryRun from "./sentry";
import { getClientEnv } from "./tools";
import { parseTraceIdFromUrl, setTraceId } from "./track-id";
import { applyHostLoginState } from "./host-login-state";

/**
 * 初始化方法汇总执行
 * @param appName 应用名称，用于确定 Sentry DSN
 */
export const initial = ({ appName }: { appName: string }) => {
  // 必须最先执行：SentryRun / initGdp / track-id 都会读 sessionStorage 或 cookie 里的
  // uid，宿主已登出或已切号时要先把残留身份对齐，避免上报和请求头带上错误的 uid
  applyHostLoginState();
  SentryRun(appName);
  initHtmlFontSize();
  initVConsole();
  initGdp();
  // 从 URL 提取 traceId 并立即存储（不再依赖 UID）
  const traceId = parseTraceIdFromUrl();
  if (traceId) {
    setTraceId(traceId);
  }
};

/**
 * 初始化html的fontSize，以设计稿宽度750px为基准
 */
const initHtmlFontSize = (UIWidth = 750) => {
  const screenWidth = document.documentElement.clientWidth || window.innerWidth;
  const fontSize = screenWidth / UIWidth;
  document.documentElement.style.fontSize = `${fontSize}px`;
};

/**
 * 初始化VConsole
 */
const initVConsole = () => {
  const env = getClientEnv();
  if (env !== "product") {
    import("vconsole").then((VConsole) => {
      new VConsole.default();
    });
  }
};
